import type { RouteRecordRaw } from 'vue-router';
import { companyRoutesDictionary } from './company-routes.dictionary';

export const companiesRoutesConfig: RouteRecordRaw = {
  ...companyRoutesDictionary.company.root,
  redirect: { name: companyRoutesDictionary.company.list.name },
  children: [
    {
      ...companyRoutesDictionary.company.list,
      component: () => import('../pages/List/ListCompanyPage.vue'),
    },
    {
      ...companyRoutesDictionary.company.create,
      component: () => import('../pages/Create/CreateCompanyPage.vue'),
    },
    {
      ...companyRoutesDictionary.company.createLegacy,
      component: () => import('../pages/Create/LegacyCreateCompanyPage.vue'),
    },
    {
      ...companyRoutesDictionary.company.update,
      component: () => import('../pages/Edit/EditCompanyPage.vue'),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.detail,
      component: () => import('../pages/Detail/CompanyDetailPage.vue'),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.setCreditLimits,
      component: () =>
        import('../pages/SetCreditLimits/SetCreditLimitsPage.vue'),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.chooseCompanyCreditTypes,
      component: () =>
        import(
          '../pages/ChooseCompanyCreditTypes/ChooseCompanyCreditTypes.vue'
        ),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.chooseCompanyCardType,
      component: () =>
        import('../pages/ChooseCompanyCardType/ChooseCompanyCardType.vue'),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.editFinancialInfo,
      component: () =>
        import('../pages/EditFinancialInfo/EditFinancialInfo.vue'),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.createFinancialInfo,
      component: () =>
        import('../pages/CreateFinancialInfo/CreateFinancialInfo.vue'),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.chooseFlexibleBenefits,
      component: () =>
        import('../pages/ChooseFlexibleBenefits/ChooseFlexibleBenefits.vue'),
      props: true,
    },
    {
      ...companyRoutesDictionary.company.editWelfarePlan,
      component: () =>
        import('../pages/EditWelfarePlan/EditWelfarePlanPage.vue'),
      props: true,
    },
  ],
};
